import * as React from 'react';
import withRoot from '../modules/withRoot';
import { Box, Container, Grid, TextField } from '@mui/material';
import Button from '../modules/components/Button';

function ContactForm() {
  const onLoad = (event) => {
    window.location = '/contact';
  };

  const onSubmit = (event) => {
    alert('問い合わせを受け付けました。');
  };

  return (
    <Container sx={{ pt: 8, pb: 4, mb: 5 }}>
      <Box sx={{ mt: 5, ml: 0, minHeight: '50vh' }}>
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item sx={{ width: '80%' }}>
            <form
              id="contact-form"
              action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSfu4JS4I6HTsH_hPRUoQ8tRNoMiTxF-CYDYDmKuIefiBReskg/formResponse"
              method="post"
              target="hidden_iframe"
              onSubmit={onSubmit}
            >
              <iframe
                title="hidden_iframe"
                name="hidden_iframe"
                id="hidden_iframe"
                style={{ display: 'none' }}
                onLoad={onLoad}
              ></iframe>
              <Grid item>
                <TextField fullWidth required id="name" label="名前" name="entry.679144693" margin="normal" />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  required
                  id="email"
                  label="メールアドレス"
                  name="entry.838243266"
                  margin="normal"
                  type="email"
                  inputProps={{
                    pattern: '.+@.+..+',
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  required
                  id="tell"
                  label="電話番号"
                  name="entry.666919486"
                  margin="normal"
                  type="tel"
                />
              </Grid>
              <Grid item>
                <TextField fullWidth required id="address" label="住所" name="entry.1638706060" margin="normal" />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  required
                  id="message"
                  label="問い合わせ内容"
                  name="entry.1483628442"
                  margin="normal"
                  multiline
                  rows={8}
                />
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={2}
                style={{ marginTop: 20 }}
              >
                <Grid item>
                  <Button
                    type="reset"
                    size="small"
                    sx={{
                      bgcolor: 'transparent',
                      color: 'text.secondary',
                      border: (theme) => `1px solid ${theme.palette.line}`,
                      '&:hover': { bgcolor: 'kinari' },
                    }}
                  >
                    クリア
                  </Button>
                </Grid>
                <Grid item>
                  <Button type="submit">送信する</Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default withRoot(ContactForm);
